import * as React from "react";
import { FieldArray } from "redux-form";

import { DropzoneMulti } from "../../../components";
import { ProjectInfoFormProps } from "./ProjectInfoForm";

const MaterialField = (props: ProjectInfoFormProps) => (
  <div className="form-group">
    <label className="control-label col-md-4">
      Tệp đính kèm
      <p className="help-block">
        Bạn có thể tải lên logo của doanh nghiệp, văn bản hoặc bất kỳ hình mẫu
        nào đó bạn muốn sản phẩm của mình trông kiểu như vậy !
      </p>
    </label>
    <div className="col-md-8">
      <FieldArray
        props={{ className: "form-control form-control-dropzone" }}
        name="material"
        component={DropzoneMulti}
      />
    </div>
  </div>
);

export default MaterialField;



// WEBPACK FOOTER //
// ./src/routes/Step4/components/MaterialField.tsx